import {Skeleton, SkeletonProps} from '@heroui/react'
import Image, {ImageProps} from 'next/image'
import React, {useState} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const AmyImage = ({
  skeletonProps,
  ...props
}: {
  skeletonProps?: SkeletonProps
} & ImageProps) => {
  const [isLoading, setIsLoading] = useState(true)
  return (
    <>
      <Skeleton
        {...skeletonProps}
        className={cn('w-full h-full', skeletonProps?.className)}
        isLoaded={!isLoading}
      />
      <Image
        {...props}
        alt={props.alt || 'AmyImage'}
        onLoad={() => setIsLoading(false)}
      />
    </>
  )
}

export default AmyImage
